import { render, staticRenderFns } from "./fwdakahouse.vue?vue&type=template&id=9e2131e2&class=component&"
import script from "./fwdakahouse.vue?vue&type=script&lang=js&"
export * from "./fwdakahouse.vue?vue&type=script&lang=js&"
import style0 from "./fwdakahouse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e2131e2')) {
      api.createRecord('9e2131e2', component.options)
    } else {
      api.reload('9e2131e2', component.options)
    }
    module.hot.accept("./fwdakahouse.vue?vue&type=template&id=9e2131e2&class=component&", function () {
      api.rerender('9e2131e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/renwu/fwdakahouse.vue"
export default component.exports